import { NotificationTypesEnum } from '../enums/notification-types.enum';

export enum NotificationGroupEnum {
	Weekly = 'Weekly',
	Follower = 'Follower',
	EventAttendee = 'EventAttendee',
	EventHost = 'EventHost',
	Membership = 'Membership',
	Chat = 'Chat',
	Post = 'Post',
	Challenge = 'Challenge',
	Mailing = 'Mailing',
	// Interest = 'Interest',
}

export const NotificationGroupsMap: Record<NotificationGroupEnum, NotificationTypesEnum[]> = {
	Weekly: [
		NotificationTypesEnum.SundaySweatSchedule,
		NotificationTypesEnum.MondayFreshGoals,
		NotificationTypesEnum.ThursdayInspiringReads,
		NotificationTypesEnum.SundayWellness,
		NotificationTypesEnum.SundayPlanWorkout,
	],
	Follower: [
		NotificationTypesEnum.FollowRequestAccepted,
		NotificationTypesEnum.NewFollower,
		NotificationTypesEnum.NewFollowerRequest,
		NotificationTypesEnum.NewMutualSubscription,
		NotificationTypesEnum.HostYouFollowCreatedEvent,
		// NotificationTypesEnum.NewJournalFromYourSubscription,
	],
	EventAttendee: [
		NotificationTypesEnum.EventUpdated,
		NotificationTypesEnum.EventEnded,
		NotificationTypesEnum.EventCanceled,
		NotificationTypesEnum.EventInstanceCanceled,
		NotificationTypesEnum.EventInvitationAccepted,
		NotificationTypesEnum.EventInvitationDeclined,
		NotificationTypesEnum.UserJoinedEvent,
		NotificationTypesEnum.UserInvitedToEvent,
		NotificationTypesEnum.UserAddedToEventInstanceFromWaitlist,
		NotificationTypesEnum.YouHaveReceivedTicket,
		NotificationTypesEnum.EventYouAttendedStartsIn10Minutes,
		NotificationTypesEnum.UserNotifiedEventSpotAvailable,
		NotificationTypesEnum.UserJoinedDonationBasedEvent,
	],
	EventHost: [
		NotificationTypesEnum.CongratsEventPublished,
		NotificationTypesEnum.HostedEventEnded,
		NotificationTypesEnum.UserEventOrderRefunded,
		NotificationTypesEnum.UserEventOrderNotRefunded,
		NotificationTypesEnum.UserHasPendingRefunds,
		NotificationTypesEnum.UserMadeDonationForEvent,
		NotificationTypesEnum.YourEventStartsIn24Hours,
		NotificationTypesEnum.YourEventStartsIn1Hour,
		NotificationTypesEnum.NewCommunityProfileAdmin,
	],
	Membership: [NotificationTypesEnum.MembershipPaused],
	Chat: [
		NotificationTypesEnum.NewJoinGroupChatRequest,
		NotificationTypesEnum.JoinGroupChatRequestAccepted,
		NotificationTypesEnum.JoinGroupChatRequestDeclined,
	],
	Post: [
		NotificationTypesEnum.NewCommentOnYourPost,
		NotificationTypesEnum.NewCommentNearYourComment,
		NotificationTypesEnum.NewReactionToYourPost,
		NotificationTypesEnum.NewLikeOnYourComment,
		NotificationTypesEnum.NewReplyToYourComment,
		NotificationTypesEnum.NewLikeOnYourReply,
		NotificationTypesEnum.SomebodyMentionedYou,
		NotificationTypesEnum.PastEventPublishedBySweatPal,
		// NotificationTypesEnum.NewReactionToPastEvent,
	],
	Challenge: [NotificationTypesEnum.ChallengeStarted, NotificationTypesEnum.ChallengeWeekStarted],
	Mailing: [
		NotificationTypesEnum.PersonalizedMailing,
		NotificationTypesEnum.EventMassInvitation,
		NotificationTypesEnum.MarkdownNotification,
	],
	// Interest: [
	// 	NotificationTypesEnum.NewSystemInterestCreated,
	// 	NotificationTypesEnum.SystemInterestDeleted,
	// ],
};
